import { IkasBaseModel } from "../../base";
import { IkasCustomerAttributeOption } from "./option";
import { IkasCustomerAttributeSalesChannel } from "./sales-channel";
import { IkasCustomerAttributeTranslation } from "./translation";

export type IkasCustomerAttribute = {
  description: string | null;
  name: string;
  type: IkasCustomerAttributeType;
  options: IkasCustomerAttributeOption[] | null;
  salesChannels: IkasCustomerAttributeSalesChannel[] | null;
  translations?: IkasCustomerAttributeTranslation[] | null;
} & IkasBaseModel;

export enum IkasCustomerAttributeType {
  BOOLEAN = "BOOLEAN",
  CHOICE = "CHOICE",
  DATETIME = "DATETIME",
  MULTIPLE_CHOICE = "MULTIPLE_CHOICE",
  NUMERIC = "NUMERIC",
  TEXT = "TEXT",
}
